import { render, staticRenderFns } from "./deleteInspectionPlan.vue?vue&type=template&id=51604878&scoped=true"
import script from "./deleteInspectionPlan.vue?vue&type=script&lang=js"
export * from "./deleteInspectionPlan.vue?vue&type=script&lang=js"
import style0 from "./deleteInspectionPlan.vue?vue&type=style&index=0&id=51604878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51604878",
  null
  
)

export default component.exports